/* eslint-disable no-nested-ternary */
import React, {useState, useEffect} from 'react';
import { ImageLoader } from '../components/common';
import banner1 from '../images/banner1.jpg';
import banner2 from '../images/banner2.jpg';
import banner3 from '../images/banner3.jpg';
import banner4 from '../images/banner4.jpg';
import banner5 from '../images/banner5.jpg';
import banner6 from '../images/banner6.jpg';

export const displayDate = (timestamp) => {
  const date = new Date(timestamp);

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'
  ];

  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  // return day + ' ' + monthNames[monthIndex] + ' ' + year;
  return `${monthNames[monthIndex]} ${day}, ${year}`;
};

export const displayMoney = (n) => {
  const format = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });

  // or use toLocaleString()
  return format.format(n);
};

export const calculateTotal = (arr) => {
  if (!arr || arr?.length === 0) return 0;

  const total = arr.reduce((acc, val) => acc + val, 0);

  return total.toFixed(2);
};

export const displayActionMessage = (msg, status = 'info') => {
  const div = document.createElement('div');
  const span = document.createElement('span');

  div.className = `toast ${status === 'info'
    ? 'toast-info'
    : status === 'success'
      ? 'toast-success'
      : 'toast-error'
    // eslint-disable-next-line indent
    }`;
  span.className = 'toast-msg';
  span.textContent = msg;
  div.appendChild(span);


  if (document.querySelector('.toast')) {
    document.body.removeChild(document.querySelector('.toast'));
    document.body.appendChild(div);
  } else {
    document.body.appendChild(div);
  }

  setTimeout(() => {
    try {
      document.body.removeChild(div);
    } catch (e) {
      console.log(e);
    }
  }, 3000);
};
export const Banner = (bannerId) => {
  switch (bannerId) {
    case '1':
      return (
        <ImageLoader
          alt="Banner"
          className="user-profile-banner-img"
          src={banner1}
        />
      ); case '2':
      return (
        <ImageLoader
          alt="Banner"
          className="user-profile-banner-img"
          src={banner2}
        />
      ); case '3':
      return (
        <ImageLoader
          alt="Banner"
          className="user-profile-banner-img"
          src={banner3}
        />
      ); case '4':
      return (
        <ImageLoader
          alt="Banner"
          className="user-profile-banner-img"
          src={banner4}
        />
      ); case '5':
      return (
        <ImageLoader
          alt="Banner"
          className="user-profile-banner-img"
          src={banner5}
        />
      ); case '6':
      return (
        <ImageLoader
          alt="Banner"
          className="user-profile-banner-img"
          src={banner6}
        />
      );
    default:
      console.log('No banner by this name!');
  }
};

export const getHeader = (bannerId) => {
  switch (bannerId) {
    case '1':
      return (
        banner1
      ); case '2':
      return (
        banner2
      ); case '3':
      return (
        banner3
      ); case '4':
      return (
        banner4
      ); case '5':
      return (
        banner5
      ); case '6':
      return (
        banner6
      );
    default:
      console.log('No banner by this name!');
  }
};

export const logEvent = (name) => (event) => {
  console.log(`[${name}]`, event);
};

export const Result = ({ children }) => <div className="result">{children}</div>;

export const ErrorResult = ({ children }) => (
  <div className="error">{children}</div>
);

// Demo hook to dynamically change font size based on window size.
export const useDynamicFontSize = () => {
  const [fontSize, setFontSize] = useState(
    window.innerWidth < 450 ? '14px' : '18px'
  );

  useEffect(() => {
    const onResize = () => {
      setFontSize(window.innerWidth < 450 ? '14px' : '18px');
    };

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return fontSize;
};

export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
  
  // These options are needed to round to whole numbers if that's what you want.
  // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

// export const apiUrl = 'http://localhost:5001/my-break-up-registry-llc/us-central1/app'
export const apiUrl = 'https://us-central1-my-break-up-registry-llc.cloudfunctions.net/app'
